import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import FooterTickerRail from './FooterTickerRail';
import { PRODUCT_LINES } from '../data/products';

const CERTS = ['ISO 9001', 'ISO 14001', 'FDA 21 CFR', 'REACH', 'RoHS', 'HALAL', 'EN 71-3', 'BPA-Free'];

export default function Footer() {
  return (
    <footer className="footer-ht" data-palette="navy">
      <FooterTickerRail />
      <div className="footer-ht__inner">
        <div className="footer-ht__main">
          <div className="footer-ht__brand">
            <span className="logo-frame logo-frame--footer">
              <BrandLogo placement="footer" />
            </span>
            <p className="footer-ht__about">
              Engineering color, function, and sustainability into every polymer solution — from laboratory to
              production line, and your product to the world.
            </p>
            <div className="footer-ht__signal">
              <span className="footer-ht__signal-dot" />
              Systems operational · Global technical network
            </div>
          </div>

          <div className="footer-ht__col" data-accent="gold">
            <h5>Products</h5>
            {PRODUCT_LINES.map((line) => (
              <Link key={line.id} to={`/products#${line.id}`}>
                {line.name}
              </Link>
            ))}
          </div>

          <div className="footer-ht__col" data-accent="green">
            <h5>Company</h5>
            <Link to="/innovation">Case Studies</Link>
            <Link to="/#innovation">Innovation Lab</Link>
            <Link to="/sustainability">Sustainability</Link>
            <Link to="/#markets">Markets</Link>
            {/* <Link to="/#gallery">
              Gallery
            </Link> */}
          </div>

          <div className="footer-ht__col" data-accent="blue">
            <h5>Contact</h5>
            <Link to="/contact">Contact form</Link>
            <span>info@auraluxmaterials.com</span>
            <span>Tech@auraluxmaterials.com</span>
            <span className="footer-ht__loc">Mumbai · Dubai · Singapore</span>
          </div>
        </div>

        <div className="footer-ht__cert-wrap">
          <div className="footer-ht__cert-track">
            {CERTS.map((cert) => (
              <span key={cert} className="footer-ht__cert">
                {cert}
              </span>
            ))}
          </div>
        </div>

        <div className="footer-ht__bot">
          <p>© 2026 Auralux Global Pvt. Ltd. · auraluxmaterials.com</p>
          <span className="footer-ht__version">Build 2026.4 · Precision polymer systems</span>
        </div>
      </div>
    </footer>
  );
}
